<div class="banner" *ngIf="shouldShowBanner">
  <div class="elements">
    <p>Viewing as {{ userFullName }}</p>
    <button (click)="returnFromViewAs()">Return</button>
  </div>
</div>
